import React, { Children, cloneElement, isValidElement } from "react";
import "./ResponsiveTable.css";

const textOf = node => Children.toArray(node).map(item => isValidElement(item) ? textOf(item.props.children) : String(item)).join("");
const flatten = children => Children.toArray(children).flatMap(child => isValidElement(child) && child.type === React.Fragment ? flatten(child.props.children) : [child]);

// Keep one semantic table and one set of actions for desktop and mobile.
export default function ResponsiveTable({ children, className = "", ...props }) {
  const sections = flatten(children);
  const head = sections.find(section => section.type === "thead");
  const headerRow = head && flatten(head.props.children).find(row => row.type === "tr");
  const labels = headerRow ? flatten(headerRow.props.children).map(cell => textOf(cell.props.children) || "İşlem") : [];
  return <table {...props} className={`responsive-records ${className}`}>{sections.map(section => {
    if (!isValidElement(section) || section.type !== "tbody") return section;
    return cloneElement(section, {}, flatten(section.props.children).map(row => {
      if (!isValidElement(row) || row.type !== "tr") return row;
      let column = 0;
      return cloneElement(row, {}, flatten(row.props.children).map(cell => {
        if (!isValidElement(cell)) return cell;
        const label = labels[column];
        column += cell.props.colSpan || 1;
        return cloneElement(cell, { "data-label": cell.props.colSpan > 1 ? undefined : label, className: `${cell.props.className || ""} ${cell.props.colSpan > 1 ? "responsive-empty" : ""}` });
      }));
    }));
  })}</table>;
}
